"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21.19 21.19 2.81 2.81a.996.996 0 0 0-1.41 0C1 3.2 1 3.83 1.39 4.22l.84.84c-.14.28-.22.6-.22.94L2 18c0 1.11.89 2 2 2h13.17l2.61 2.61c.39.39 1.02.39 1.41 0s.39-1.03 0-1.42M4 12V8h1.17l4 4zm2.83-8H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L14.83 12H20V8h-9.17z"
}), 'CreditCardOffRounded');